import { render, staticRenderFns } from "./SelectableTag.vue?vue&type=template&id=69f1131d&scoped=true&"
import script from "./SelectableTag.vue?vue&type=script&lang=js&"
export * from "./SelectableTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1131d",
  null
  
)

export default component.exports